
import React from "react";

interface LoaderProps {
  size?: number; // Size of the loader in pixels (default: 48)
  
}

export const Loader: React.FC<LoaderProps> = ({ size = 48 }) => {

  return (
    <div className="flex justify-center items-center h-64">
        <div className="loader border-t-4 border-[#215564]  border-solid rounded-full w-12 h-12 animate-spin"></div>
    </div>
  );
};






  
